import React from 'react'
import { Table } from 'react-bootstrap'

import OcTabLayout from '../../layout/OcTabLayout'
import useOcOrderActions from '../../hooks/useOcOrderActions'

import { safeValue, safeMoney } from '../../helpers/tableUtils'
import { buildReprocessHandler } from '../../helpers/reprocessHelper'
import { canManagePocOrders } from '../../../../global_context/capabilities/pocCapabilities'

const OcInvoicedTab = ({
  lines = {},
  downloads = {},
  tabsOrders = {},
  onReprocessSuccess,
  summary = {},
  last_activity_at = {},
  status = {},
  insertionErrorDetails
}) => {
  const invoice_items = lines.invoice_items ?? []

  const canWriteReprocess = canManagePocOrders()

  const {
    downloadPurchaseOrder,
    reprocessPurchaseOrder,
    loadingDownload,
    loadingReprocess
  } = useOcOrderActions({
    purchaseOrderFileId: downloads.purchase_order_file_id,
    purchaseOrderFileName: downloads.file_name,
    orderId: tabsOrders.order_id
  })

  const { canReprocess, handleReprocess } = buildReprocessHandler({
    tabsOrders,
    summary,
    reprocessPurchaseOrder,
    onReprocessSuccess,
    status
  })

  const actions = [
    {
      label: 'DESCARGAR OC',
      icon: 'download_2',
      className: 'download-purchase-order',
      onClick: downloadPurchaseOrder,
      disabled: !downloads.purchase_order_file_id || loadingDownload
    },
    canWriteReprocess && {
      label: 'REPROCESAR',
      icon: 'refresh',
      className: 'reload-purchase-order',
      onClick: handleReprocess,
      disabled: !canReprocess || loadingReprocess
    }
  ].filter(Boolean)

  return (
    <OcTabLayout
      summary={summary}
      tabsOrders={tabsOrders}
      last_activity_at={last_activity_at}
      title="Detalles de orden de compra"
      actions={actions}
      status={status}
      insertionErrorDetails={insertionErrorDetails}
    >
      <b>Factura:</b>

      <Table hover responsive className="mt-2 oc-fixed-table">
        <thead className="table-header-gray">
          <tr>
            <th className="col-w-140">CÓDIGO</th>
            <th className="col-w-260">DESCRIPCIÓN</th>
            <th className="col-w-80">CANT.</th>
            <th className="col-w-120">EMPAQUE</th>
            <th className="col-w-100">PRECIO</th>
            <th className="col-w-110">TOTAL</th>
          </tr>
        </thead>
        <tbody>
          {invoice_items.length === 0 ? (
            <tr>
              <td colSpan="6">No hay resultados</td>
            </tr>
          ) : (
            invoice_items.map(line => (
              <tr key={line.id}>
                <td className="oc-td-text">{safeValue(line.package_db_ref)}</td>
                <td className="oc-td-text">{safeValue(line.product_name)}</td>
                <td className="oc-td-money">{safeValue(line.quantity)}</td>
                <td className="oc-td-text">{safeValue(line.package_unit)}</td>
                <td className="oc-td-money">{safeMoney(line.price)}</td>
                <td className="oc-td-money">{safeMoney(line.total_price)}</td>
              </tr>
            ))
          )}
        </tbody>
      </Table>
    </OcTabLayout>
  )
}

export default OcInvoicedTab
